export default __webpack_public_path__ + "static/media/Chalten.05a02384.png";